var _path, _rect, _rect2, _rect3, _g, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6306_19045",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 22,
    height: 22
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z",
    fill: "#E3E4FF",
    stroke: "#44475C",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6306_19045)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "black",
    fillOpacity: 0.2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#CD3438"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_6306_19045",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_6306_19045)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 17,
    r: 17,
    transform: "matrix(-1 0 0 1 41 -17)",
    fill: "url(#paint0_linear_6306_19045)"
  })))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0098 9C15.0098 8.20435 14.6937 7.44129 14.1311 6.87868C13.5685 6.31607 12.8054 6 12.0098 6C11.2141 6 10.451 6.31607 9.88843 6.87868C9.32582 7.44129 9.00977 8.20435 9.00977 9V11C9.00977 11.7956 9.32582 12.5587 9.88843 13.1213C10.451 13.6839 11.2141 14 12.0098 14C12.8054 14 13.5685 13.6839 14.1311 13.1213C14.6937 12.5587 15.0098 11.7956 15.0098 11V9Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.45996 19.9697C6.28625 19.0455 7.29451 18.302 8.42163 17.7857C9.54875 17.2695 10.7702 16.9917 12.0098 16.9697C13.1922 16.9853 14.3597 17.2355 15.4446 17.7058C16.5295 18.1762 17.5103 18.8573 18.3298 19.7097",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6306_19045",
    x1: 34,
    y1: 0,
    x2: -2.69152e-7,
    y2: 36.125,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDD203"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CD3438"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.20b2e42b4078f60c8dc32c9d6818e678.svg";
export { ForwardRef as ReactComponent };